import $ from "jquery";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import "swiper/css";
import "swiper/css/navigation";
import { Swiper, SwiperSlide } from "swiper/react";
import { callGetApi, callPostApi } from "../../api/ApiCaller";
import { GET_GAME_PLAY_RESULT_POST, GET_PLAYER_BALANCE_GET, GET_TEMPLATE_DETAILS_GET, RESET_BALANCE_AMT_POST, ADD_BALANCE_AMT_POST } from "../../api/ApiConst";
import { CURRENCY_CODE, getAudioVolume, getDataFromStore, setAudioVolume, TEMPLATE_ID } from "../../utils/CookiesUtils";
import { getFormattedAmount, getFormattedAmountN, getFormattedAmountWithDenomination, getFormattedAmountWithDenominationGamePlay, getFormattedAmountWithDenominationGamePlayBy100, isEmpty } from "../../utils/TextUtils";
import ModalHalloween from "../common/ModalHalloween";
import LineImages from "../LineImages";
import NumberLineImages from "../NumberLineImages";
import HalloweenMachine from "../HalloweenMachine";
import Bonus01Strawberry from "../bonus/Bonus01Strawberry";
import RouletteBonus from "../bonus/RouletteBonus";
import CauldronBonus from "../bonus/CauldronBonus";
import HalloweenDiceBonus from "../bonus/HalloweenDiceBonus";
import PoolSpinBonus from "../bonus/PoolSpinBonus";
import GiraLuzBonus from "../bonus/GiraLuzBonus";
import Bonus08SpinningStrawberry from "../bonus/Bonus08SpinningStrawberry";
import Bonus09Bomb from "../bonus/Bonus09Bomb";
import Bonus10Bomb from "../bonus/Bonus10Bomb";
import PumpkinBonus from "../bonus/PumpkinBonus";
import CoinContainer from "../CoinContainer";
import Bonus01BombaStrawberry from "../bonus/Bonus01BombaStrawberry";
import BombaRouletteBonus from "../bonus/BombaRouletteBonus";
import BombaCauldronBonus from "../bonus/BombaCauldronBonus";

const HalloweenBombaGame = () => {
    const navigate = useNavigate();
    const machineRef = useRef(null);

    const templateId = getDataFromStore(TEMPLATE_ID);
    const [templateData, setTemplateData] = useState(null);
    const [templateNumber, setTemplateNumber] = useState(25);
    const [walletBalance, setWalletBalance] = useState(0);

    const [gameResult, setGameResult] = useState(null);
    const [winnings, setWinnings] = useState(0);
    const [stopMachineFlag, setStopMachineFlag] = useState(false);
    const [showInsufficientFundModel, setShowInsufficientFundModel] = useState(false);
    const [showAutoNumberPickerModel, setShowAutoNumberPickerModel] = useState(false);
    const [showSettingModel, setShowSettingModel] = useState(false);
    const [ruleImagesArray, setRuleImagesArray] = useState([]);
    const [activeLineNumber, setActiveLineNumber] = useState(null);
    const [showHelpModel, setShowHelpModel] = useState(false);
    const [showAjudaModel, setShowAjudaModel] = useState(false);
    const [showBonusBombaModel, setShowBonusBombaModel] = useState(false);
    const [selectedNumber, setSelectedNumber] = useState(1);
    const [slotRunning, setSlotRunning] = useState(false);
    const [denomination, setDenomination] = useState(0.01);
    const [betMultiplier, setBetMultiplier] = useState(null);
    const [accumuladoList, setAccumuladoList] = useState([])

    const [accumuladoBonusNumber, setAccumuladoBonusNumber] = useState(null);
    const [accumuladoBonusNumberMap, setAccumuladoBonusNumberMap] = useState({});
    const [accumuladoActualValue, setAccumuladoActualValue] = useState(0);

    const [pagoWinningCounter, setPagoWinningCounter] = useState(null);
    const [remainingFreeSpin, setRemainingFreeSpin] = useState(0);
    const [showFreeSpinBanner, setShowFreeSpinBanner] = useState(false);
    const freeSpinBannerPending = useRef(false);
    // Holds the new bonus number / map / value from a spin result so the number
    // list highlight is applied only when the ball arrives (slot stops), not the
    // moment the API responds.
    const pendingBonusUpdateRef = useRef(null);
    // False from the moment a spin starts until its result arrives; a line button
    // may only stop a reel once the new result matrix is available.
    const resultReadyRef = useRef(false);
    // Reels pressed before the result landed. They are not thrown away: the API
    // callback replays them the instant the matrix is available, so a press always
    // does something instead of silently dying.
    const pendingStopRef = useRef([]);
    // True from the moment the giro loop starts until it is stopped, so the
    // "last reel locked" watcher knows whether there is a loop left to kill.
    const spinLoopActiveRef = useRef(false);
    const [animateColumn, setAnimateColumn] = useState([false, false, false, false, false]);
    // Mirror of animateColumn for the keydown handler: that effect does not list
    // animateColumn in its deps, so its closure would otherwise hold the value
    // from the start of the spin and mis-read which reels are still turning.
    const animateColumnRef = useRef(animateColumn);
    useEffect(() => { animateColumnRef.current = animateColumn; }, [animateColumn]);
    const [autoBetOn, setAutoBetOn] = useState(false);
    const [autoCount, setAutoCount] = useState(0);
    const [playMachine, setPlayMachine] = useState(0);
    const [showCoins, setShowCoins] = useState(false);

    const [buttonFlag, setButtonFlag] = useState(false);
    const [jogarButtonFlag, setJogarButtonFlag] = useState(false);
    const [isBalanceAdding, setIsBalanceAdding] = useState(false);

    const [showBonusModel, setShowBonusModel] = useState(false);
    const [accumuladoWin, setAccumuladoWin] = useState({ winAmount: 0, winIndex: -1 });
    const [bonusWinnings, setBonusWinnings] = useState(0);
    const [keyboardInput, setKeyboardInput] = useState(false);
    const [resetAmntModel, setResetAmntModel] = useState(false);
    const [leftImage, setLeftImage] = useState('text');

    const audioContextRef = useRef(null);
    const slotSourceNodeRef = useRef(null);
    const slotAudioBufferRef = useRef(null);
    const slotGainNodeRef = useRef(null);
    // The sounds that have to answer a press or a landing on the spot, decoded up
    // front. Measured in Chrome on this project: a media element's FIRST play()
    // takes ~960ms to produce a sample even at readyState 4, and ~16ms on every
    // play after that. A buffer source starts on the sample every time.
    const sfxBuffersRef = useRef({});
    const SFX_FILES = {
        WheelStopWav: "assets/wheel-stop.wav",
        AwardWav: "assets/aposta.wav",
    };

    useEffect(() => {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        const context = new AudioContext();
        audioContextRef.current = context;

        const decodeInto = (url, store) =>
            fetch(url)
                .then(response => response.arrayBuffer())
                .then(arrayBuffer => context.decodeAudioData(arrayBuffer))
                .then(store)
                .catch(e => console.warn("Audio preload failed, falling back to the <audio> tag.", url, e));

        decodeInto('assets/giro_loop.mp3', (audioBuffer) => {
            slotAudioBufferRef.current = audioBuffer;
        });

        Object.entries(SFX_FILES).forEach(([soundTagId, url]) => {
            decodeInto(url, (audioBuffer) => {
                sfxBuffersRef.current[soundTagId] = audioBuffer;
                // Says out loud which path each sound is on, so a complaint about
                // one lagging can be read off instead of guessed at.
                console.info(
                    `[audio] ${soundTagId} on Web Audio: ${Math.round(audioBuffer.duration * 1000)}ms clip, ` +
                    `context ${context.sampleRate}Hz. Timings: window._audioPaths()`
                );
            });
        });

        return () => {
            if (context.state !== 'closed') {
                context.close();
            }
        };
    }, []);

    let currency = getDataFromStore(CURRENCY_CODE);

    const lineOptions = [1, 5, 9, 15, 25];

    useEffect(() => {
        getWalletBalance();
        getTemplateData();
    }, [templateId]);

    useEffect(() => {
        if (autoCount > 0 || autoCount === -1) {
            placeBet();
        } else {
            setAutoBetOn(false);
            setAutoCount(0);
        }
    }, [playMachine]);

    useEffect(() => {
        if (slotRunning) {
            setLeftImage('group');
        } else if (gameResult !== null) {
            // Ball has arrived (slot stopped): now apply the new bonus number/map/value
            // so the number list highlight appears in sync with the ball, not before.
            let appliedBonusNumber = accumuladoBonusNumber;
            let appliedBonusNumberMap = accumuladoBonusNumberMap;
            if (pendingBonusUpdateRef.current) {
                appliedBonusNumber = pendingBonusUpdateRef.current.bonusNumber;
                appliedBonusNumberMap = pendingBonusUpdateRef.current.bonusNumberMap;
                setAccumuladoBonusNumber(pendingBonusUpdateRef.current.bonusNumber);
                setAccumuladoBonusNumberMap(pendingBonusUpdateRef.current.bonusNumberMap);
                setAccumuladoActualValue(pendingBonusUpdateRef.current.actualValue);
                pendingBonusUpdateRef.current = null;
            }
            const currentBonusNumber = appliedBonusNumber ?? gameResult?.accumuladoList?.[2]?.accumuladoMetaData?.accumuladoBonusNumber;
            if (currentBonusNumber !== null && currentBonusNumber !== undefined) {
                setLeftImage('bonus');
                // Only play the ball sound when the drawn number matches one of the
                // numbers shown in the list (the bonus number map). If the ball number
                // is not in the list, stay silent.
                const bonusNumberMap = appliedBonusNumberMap || {};
                const isNumberInList = Object.prototype.hasOwnProperty.call(bonusNumberMap, String(currentBonusNumber));
                if (isNumberInList) {
                    playSoundById("BolaOgg");
                }
            } else {
                setLeftImage('text');
            }
        }
    }, [slotRunning]);

    useEffect(() => {
        if (showFreeSpinBanner) {
            const timer = setTimeout(() => {
                setShowFreeSpinBanner(false);
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, [showFreeSpinBanner]);

    const getWalletBalance = () => {
        callGetApi(GET_PLAYER_BALANCE_GET, {}, (response) => {
            if (response.errorCode === 0) {
                const balance = Math.round(response.responsePacket * 100.0) / 100.0;
                setWalletBalance(balance);
            }
        });
    };

    const getTemplateData = () => {
        if (!templateId) { return; }
        callGetApi(GET_TEMPLATE_DETAILS_GET.replaceAll("{recordId}", templateId), {}, (response) => {
            if (response.errorCode === 0) {
                const res = response.responsePacket;
                setKeyboardInput(response.responsePacket.keyboardInput)

                let accList = res?.accumuladoList || [];
                setAccumuladoList(accList);

                if (accList.length > 2 && accList[2]?.accumuladoMetaData) {
                    setAccumuladoBonusNumber(accList[2].accumuladoMetaData.accumuladoBonusNumber);
                    setAccumuladoBonusNumberMap(accList[2].accumuladoMetaData.accumuladoBonusNumberMap || {});
                    setAccumuladoActualValue(accList[2]?.accumuladoActual || 0);
                }

                setRemainingFreeSpin(res?.remainingFreeSpin || 0);
                setTemplateData(res);
                setBetMultiplier(res.betAmountList[0]);
                if (res) {
                    if (res.slotGameType === "Halloween_Bomba_25") {
                        setTemplateNumber(25);
                        setRuleImagesArray(["assets/img/rules1_25.png", "assets/img/rules2_25.png", "assets/img/rules3_25.png"]);
                    }
                }
            }
        });
    }

    const [animationTimeOutRef, setAnimationTimeOutRef] = useState([]);
    const [autoBetTimeOutRef, setAutoBetTimeOutRef] = useState(null);
    const [animationIntervalRef, setAnimationIntervalRef] = useState([]);

    // Silences the giro loop on both paths it can be playing on: the Web Audio
    // buffer source (the seamless one) and the plain <audio> tag fallback.
    const stopSpinLoopSound = () => {
        spinLoopActiveRef.current = false;
        if (slotSourceNodeRef.current) {
            try {
                slotSourceNodeRef.current.stop();
            } catch (e) { }
            slotSourceNodeRef.current = null;
        }
        const slotAudio = $("#SlotMp3")[0];
        if (slotAudio) {
            slotAudio.pause();
            slotAudio.currentTime = 0;
        }
    };

    // Both spin sounds belong to the reels, not to a timer. The landing sound used
    // to be fixed to the 3500ms timeout: stop reels by hand with the line buttons
    // and the machine could be standing still by 2000ms with the sound still a
    // second and a half out. The giro loop had the same fault, kept looping over a
    // dead machine. Watch the reels instead — every reel that locks is heard the
    // moment it locks, and the loop dies with the last one, whichever path stopped
    // them: a line button, the Jogar button, or the timers running out.
    const prevAnimateColumnRef = useRef([false, false, false, false, false]);
    useEffect(() => {
        const previous = prevAnimateColumnRef.current;
        const current = [0, 1, 2, 3, 4].map((i) => !!animateColumn[i]);
        prevAnimateColumnRef.current = current;

        const justLocked = [0, 1, 2, 3, 4].some((i) => previous[i] && !current[i]);
        if (justLocked) {
            replaySound("WheelStopWav");
        }

        if (spinLoopActiveRef.current && !current.some(Boolean)) {
            stopSpinLoopSound();
        }
    }, [animateColumn]);

    // The result has landed: honour the stop presses that arrived while the API
    // was still out. Done from an effect, not from the response handler, so the
    // stop path sees the new gameResult and the freshly registered timeouts
    // rather than the previous round's.
    useEffect(() => {
        if (!resultReadyRef.current) return;
        if (pendingStopRef.current.length === 0) return;
        flushPendingStops();
    }, [gameResult]);

    // Drops one reel out of the spin. Writes the mirror ref eagerly so a burst of
    // stops in the same tick each see the reels the previous one already took down.
    // The landing sound is not fired here — the watcher above hears the lock and
    // covers the timer-driven stops too, which never come through this function.
    const setReelStopped = (reel) => {
        animateColumnRef.current = { ...animateColumnRef.current, [reel]: false };
        setAnimateColumn((pre) => ({ ...pre, [reel]: false }));
    };

    const stopAllAnimation = () => {
        stopSpinLoopSound();
        animateColumnRef.current = [false, false, false, false, false];
        setAnimateColumn([false, false, false, false, false]);
        setSlotRunning(false);
        animationTimeOutRef.map((animateRef) => {
            clearTimeout(animateRef);
        });
        animationIntervalRef.map((animateRef) => {
            clearInterval(animateRef);
        });
        setStopMachineFlag(true);
        if (freeSpinBannerPending.current) {
            setShowFreeSpinBanner(true);
            freeSpinBannerPending.current = false;
        }
        drawWinningLineOnResult(gameResult);

        $("#CreditsCounterMp3")[0].pause();
        $("#CreditsCounterMp3")[0].currentTime = 0;
        setWinnings(0);

        let lastBalance = walletBalance;
        let gameWinn = gameResult.winnings + accumuladoWin.winAmount
        if (gameResult.winnings > 0 || accumuladoWin.winAmount > 0) {
            setButtonFlag(true);
            setWinnings(gameResult.winnings);
            if (gameResult.bonusType === "None") {
                if (accumuladoWin.winAmount > 0) {
                    setShowCoins(true)
                    setTimeout(() => {
                        setShowCoins(false)
                        animateAccumuladoWinning(lastBalance, accumuladoWin.winAmount, accumuladoWin.winIndex);
                        playWinningAnimation(lastBalance, gameResult.winnings, accumuladoWin.winAmount);
                    }, 25000);
                }
                else {
                    playWinningAnimation(lastBalance, gameResult.winnings, accumuladoWin.winAmount);
                }
            }
        }
        if (gameResult.bonusType !== "None") {
            openBonusModel();
        } else {
            setButtonFlag(false);
        }
    };

    const openBonusModel = () => {
        setTimeout(() => {
            setShowBonusModel(true);
        }, 2000);
    }

    const placeBet = () => {
        if (jogarButtonFlag) { return }
        setPagoWinningCounter(null);
        setShowAutoNumberPickerModel(false);
        $(".line-show").removeClass(" active");
        $(".number-show").removeClass("animate-blink");
        for (let i = 1; i <= selectedNumber; i++) {
            const imgDiv = document.getElementsByClassName(`line-show${i}`);
            if (imgDiv[0]) {
                imgDiv[0].classList.add("active1");
            }
        }
        let totalBetAmount = betMultiplier * selectedNumber;
        if (remainingFreeSpin <= 0) {
            if (walletBalance < totalBetAmount) {
                playSoundById("ErrorMp3");
                setShowInsufficientFundModel(true);
                setTimeout(() => {
                    setShowInsufficientFundModel(false);
                }, 3000);
                setAutoBetOn(false);
                setAutoCount(0);
                return;
            }
        }
        if (autoBetTimeOutRef !== null) {
            clearTimeout(autoBetTimeOutRef);
        }
        spinLoopActiveRef.current = true;
        playSoundById("SlotMp3", true);
        resultReadyRef.current = false;
        pendingStopRef.current = [];
        setButtonFlag(true);
        setJogarButtonFlag(true);
        setSlotRunning(true);
        setStopMachineFlag(false);
        let pAnimateColumn = [true, true, true, true, true];
        animateColumnRef.current = pAnimateColumn;
        setAnimateColumn(pAnimateColumn);
        machineRef.current.spin();

        let totalBetCount = getFormattedAmountWithDenomination(totalBetAmount, denomination);
        let payload = {
            slotLineType: `Line_${selectedNumber}`,
            betAmount: totalBetCount
        };
        let lastBalance = walletBalance;
        if (remainingFreeSpin <= 0) {
            let balance = Math.round((lastBalance - totalBetAmount) * 100) / 100.0;
            setWalletBalance(balance);
        }
        var pAnimationTimeOutRef = [];
        var pAutoBetTimeOutRef = null;

        callPostApi(GET_GAME_PLAY_RESULT_POST.replaceAll("{templateId}", templateId), payload, {}, (response) => {
            setJogarButtonFlag(false);
            if (response.errorCode === 0) {
                let gameResult = response.responsePacket;
                let updatedAccumulado = response?.responsePacket?.accumuladoList;
                let accumuladoWinningAmt = response?.responsePacket?.accumuladoActual;
                setKeyboardInput(gameResult.keyboardInput)

                setGameResult(gameResult);
                resultReadyRef.current = true;
                setRemainingFreeSpin(gameResult?.remainingFreeSpin || 0);
                const hasFreeSpinBanner = gameResult?.showFreeSpinBanner === true;
                freeSpinBannerPending.current = hasFreeSpinBanner;
                let winningIndex;

                const fixAccumuladoList = (list) => {
                    if (!Array.isArray(list) || list.length === 0) return [];
                    let updatedList = list;
                    winningIndex = updatedList.findIndex(item => item.accumuladoActual === 0);
                    if (winningIndex !== -1 && accumuladoWinningAmt > 0) {
                        updatedList[winningIndex].accumuladoActual = accumuladoWinningAmt;
                        setAccumuladoWin({
                            winAmount: accumuladoWinningAmt,
                            winIndex: winningIndex
                        });

                        if (winningIndex === 2 && updatedList[2]?.accumuladoMetaData) {
                            pendingBonusUpdateRef.current = {
                                bonusNumber: updatedList[2].accumuladoMetaData.accumuladoBonusNumber,
                                bonusNumberMap: updatedList[2].accumuladoMetaData.accumuladoBonusNumberMap || {},
                                actualValue: updatedList[2]?.accumuladoActual || 0,
                            };
                        }
                    }
                    else {
                        setAccumuladoWin({ winAmount: 0, winIndex: -1 });
                    }

                    if (list.length > 2 && list[2]?.accumuladoMetaData) {
                        // Defer the highlight/value update until the ball arrives (slot stops).
                        // Applied in the slotRunning effect so the number list lights up in sync.
                        pendingBonusUpdateRef.current = {
                            bonusNumber: list[2].accumuladoMetaData.accumuladoBonusNumber,
                            bonusNumberMap: list[2].accumuladoMetaData.accumuladoBonusNumberMap || {},
                            actualValue: list[2]?.accumuladoActual || 0,
                        };
                    }

                    return updatedList;
                };
                const newAccumuladoList = fixAccumuladoList(updatedAccumulado);
                setAccumuladoList(newAccumuladoList);

                // setReelStopped rather than a bare setAnimateColumn: it keeps the
                // mirror ref in step, so a line button pressed right after a timer
                // fired still knows which reels are genuinely left turning.
                pAnimationTimeOutRef.push(setTimeout(() => {
                    setReelStopped(0);
                }, 1500));
                pAnimationTimeOutRef.push(setTimeout(() => {
                    setReelStopped(1);
                }, 2000));
                pAnimationTimeOutRef.push(setTimeout(() => {
                    setReelStopped(2);
                }, 2500));
                pAnimationTimeOutRef.push(setTimeout(() => {
                    setReelStopped(3);
                }, 3000));
                pAnimationTimeOutRef.push(setTimeout(() => {
                    setReelStopped(4);
                    // Belt and braces — the animateColumn watcher normally gets
                    // here first, and does so even when this reel was already
                    // brought down by a line button.
                    stopSpinLoopSound();
                    if (hasFreeSpinBanner) { setShowFreeSpinBanner(true); freeSpinBannerPending.current = false; }
                    drawWinningLineOnResult(gameResult);
                    if (gameResult.bonusType === "None") {
                        let roundAccWin = accumuladoWinningAmt;
                        let winningAmountAdd = gameResult.winnings + roundAccWin
                        if (accumuladoWinningAmt > 0) {
                            setShowCoins(true)
                            setTimeout(() => {
                                setShowCoins(false);
                                animateAccumuladoWinning(walletBalance, roundAccWin, winningIndex);
                                playWinningAnimation(walletBalance, gameResult.winnings, roundAccWin);
                            }, 25000);
                        }
                        else {
                            playWinningAnimation(walletBalance, gameResult.winnings, roundAccWin);
                        }
                    }
                    else {
                        openBonusModel();
                    }

                    // Handle Auto Bet AFTER reels stop to prevent cancellation
                    if (autoBetOn && gameResult.bonusType === "None") {
                        let autoTimer = gameResult?.winnings <= 0 ? 1000 : 4000;
                        if (accumuladoWinningAmt > 0) autoTimer = 25000;

                        pAutoBetTimeOutRef = setTimeout(() => {
                            setAutoCount(prevCount => {
                                if (prevCount > 0) return prevCount - 1;
                                if (prevCount === 0) return 0;
                                return -1;
                            });
                            setPlayMachine(pCounter => pCounter + 1);
                        }, autoTimer);
                        setAutoBetTimeOutRef(pAutoBetTimeOutRef);
                        pAnimationTimeOutRef.push(pAutoBetTimeOutRef);
                    }
                }, 3500));

                pAnimationTimeOutRef.push(setTimeout(() => {
                    setSlotRunning(false);
                    if (gameResult.winnings > 0) {
                        setButtonFlag(true);
                    } else {
                        setButtonFlag(false);
                    }
                }, 4000));
                setAnimationTimeOutRef(pAnimationTimeOutRef);
            } else if (response.errorCode === 1001) {
                toast.error(response.message);
                window.location.reload();
            } else {
                setButtonFlag(false);
                setJogarButtonFlag(false);
                toast.error(response.message);
                let balance = Math.round((lastBalance) * 100) / 100.0;
                setWalletBalance(balance);
                setAnimateColumn([false, false, false, false, false]);
            }
        }, (error) => {
            setButtonFlag(false);
            setJogarButtonFlag(false);
            toast.error(error);
            let balance = Math.round((lastBalance) * 100) / 100.0;
            setWalletBalance(balance);
            setAnimateColumn([false, false, false, false, false]);
        });
    }

    const drawWinningLineOnResult = (pGameResult) => {
        if (!pGameResult || !Array.isArray(pGameResult.payLines) || !pGameResult.winnings) {
            return;
        }
        setJogarButtonFlag(true)
        if (pGameResult.winnings > 0) {
            setWinnings(pGameResult.winnings);
        }
        if (pGameResult.payLines.length > 0) {
            playSoundById("Win45Wav");
        }
        pGameResult.payLines.forEach((item) => {
            $(".line-show").removeClass("active1");
            let imgDiv = document.getElementsByClassName(item.title);
            if (imgDiv[0]) {
                imgDiv[0].classList.add("active");
            }
            let numberDiv = document.getElementsByClassName(`number-show${item.title.replace("line-show", "")}`);
            if (numberDiv[0]) {
                numberDiv[0].classList.add("animate-blink");
            }
        });
    };

    const animateAccumuladoWinning = (currentBalance, winnings, accIndex) => {
        setShowCoins(false);
        if (!winnings || winnings <= 0) return;
        let timeFactor = Math.min(Math.max(5000 / winnings, 2), 20);
        if (timeFactor * winnings < 2000) {
            timeFactor = Math.ceil(2000 / winnings);
        }
        const decrementFactor = Math.max(1, Math.ceil((winnings * timeFactor) / 500));
        let currentWinnings = winnings;
        setTimeout(() => {
            const intervalId = setInterval(() => {
                if (currentWinnings > 0) {
                    currentWinnings -= decrementFactor;
                    setAccumuladoList((prevList) => {
                        if (!Array.isArray(prevList)) return prevList;
                        const updatedList = [...prevList];
                        if (updatedList[accIndex]) {
                            updatedList[accIndex] = {
                                ...updatedList[accIndex],
                                accumuladoActual: Math.max(0, currentWinnings),
                            };

                            if (accIndex === 2 && updatedList[2]?.accumuladoMetaData) {
                                setAccumuladoBonusNumber(updatedList[2].accumuladoMetaData.accumuladoBonusNumber);
                                setAccumuladoBonusNumberMap(updatedList[2].accumuladoMetaData.accumuladoBonusNumberMap || {});
                                setAccumuladoActualValue(updatedList[2]?.accumuladoActual || 0);
                            }
                        }
                        return updatedList;
                    });
                } else {
                    clearInterval(intervalId);
                }
            }, timeFactor);
        }, 1600);
    };

    const playWinningAnimation = (currentBalance, winnings, accumWin) => {
        const totalWin = winnings + accumWin;
        if (totalWin <= 0) return;

        setIsBalanceAdding(true);

        let timeFactor = Math.min(Math.max(5000 / totalWin, 2), 20);
        if (timeFactor * totalWin < 2000) {
            timeFactor = Math.ceil(2000 / totalWin);
        }
        const incrementFactor = Math.max(1, Math.floor((totalWin * timeFactor) / 500));
        const pAnimationTimeOutRef = [...animationTimeOutRef];
        const audioElement = $("#CreditsCounterMp3")[0];
        const playAudio = () => {
            if (!audioElement) return;
            audioElement.volume = accumWin > 0 ? 0.5 : 1.0;
            audioElement.loop = true;
            audioElement.play().catch(err => console.error("Audio Play Error:", err));
        };
        const stopAudio = () => {
            if (!audioElement) return;
            audioElement.pause();
            audioElement.currentTime = 0;
        };
        const finalizeAnimation = () => {
            setWinnings(0);
            setPagoWinningCounter(totalWin);
            setWalletBalance(currentBalance + (totalWin * denomination));
            stopAudio();
            setButtonFlag(false);
            setJogarButtonFlag(false);
            setIsBalanceAdding(false);
        };
        const startPhase2 = (startFrom = totalWin) => {
            playAudio();
            let current = startFrom;
            const interval = setInterval(() => {
                if (current <= 0) {
                    clearInterval(interval);
                    finalizeAnimation();
                    return;
                }
                const step = Math.min(incrementFactor, current);
                current -= step;
                setWinnings(current);
                setPagoWinningCounter(totalWin - current);
                setWalletBalance(prev => prev + (step * denomination));
            }, timeFactor);
            setAnimationIntervalRef([interval]);
        };
        const startPhase1 = () => {
            playAudio();
            let current = winnings;
            setWinnings(current);
            const interval = setInterval(() => {
                current += incrementFactor;
                if (current >= totalWin) {
                    clearInterval(interval);
                    setWinnings(totalWin);
                    stopAudio();
                    setTimeout(() => startPhase2(totalWin), 2000);
                } else {
                    setWinnings(current);
                }
            }, timeFactor);
            setAnimationIntervalRef([interval]);
        };
        setButtonFlag(true);
        setJogarButtonFlag(true);
        if (accumWin > 0) {
            pAnimationTimeOutRef.push(setTimeout(startPhase1, 1700));
        } else {
            pAnimationTimeOutRef.push(setTimeout(() => startPhase2(winnings), 1700));
        }
        setAnimationTimeOutRef(pAnimationTimeOutRef);
    };

    const playSoundById = (soundTagId, loop = false) => {
        if (soundTagId === "SlotMp3" && slotAudioBufferRef.current && audioContextRef.current) {
            if (slotSourceNodeRef.current) {
                try {
                    slotSourceNodeRef.current.stop();
                } catch (e) { }
            }

            if (audioContextRef.current.state === 'suspended') {
                audioContextRef.current.resume();
            }

            const source = audioContextRef.current.createBufferSource();
            source.buffer = slotAudioBufferRef.current;
            source.loop = true;

            const gainNode = audioContextRef.current.createGain();
            gainNode.gain.value = getAudioVolume();
            slotGainNodeRef.current = gainNode;

            source.connect(gainNode);
            gainNode.connect(audioContextRef.current.destination);

            source.start(0);
            slotSourceNodeRef.current = source;
            return;
        }

        const sfxBuffer = sfxBuffersRef.current[soundTagId];
        if (!loop && sfxBuffer && audioContextRef.current) {
            const context = audioContextRef.current;
            if (context.state === 'suspended') {
                context.resume();
            }

            const source = context.createBufferSource();
            source.buffer = sfxBuffer;

            const gainNode = context.createGain();
            gainNode.gain.value = getAudioVolume();

            source.connect(gainNode);
            gainNode.connect(context.destination);

            source.start(0);
            return;
        }

        const audio = $("#" + soundTagId)[0];
        if (audio) {
            audio.loop = loop;
            audio.play().catch(err => console.error("Audio Play Error:", err));
        }
    };

    const setSoundLevelOfAudio = (level) => {
        $(".audioFile").prop("volume", level);
        if (slotGainNodeRef.current) {
            slotGainNodeRef.current.gain.value = level;
        }
    }

    const setNextSoundLevelOfAudio = () => {
        playSoundById("ButtonClickMp3");
        var audioVolume = getAudioVolume();
        if (audioVolume === 0) {
            audioVolume = 0.25;
        } else if (audioVolume === 0.25) {
            audioVolume = 0.50;
        } else if (audioVolume === 0.50) {
            audioVolume = 0.75;
        } else if (audioVolume === 0.75) {
            audioVolume = 1.0;
        } else if (audioVolume === 1.0) {
            audioVolume = 0;
        }
        setAudioVolume(audioVolume);
        setSoundLevelOfAudio(audioVolume);
        $("#audioVolume").prop("src", "/assets/img/sound/sound-" + audioVolume.toFixed(2) + ".png");
    }

    window._setSoundLevelOfAudio = (level) => {
        setSoundLevelOfAudio(level);
    }

    window._audioPaths = () => {
        const context = audioContextRef.current;
        return {
            onWebAudio: Object.keys(sfxBuffersRef.current),
            onAudioTag: staticResources.audioFiles
                .map(a => a.id)
                .filter(id => !sfxBuffersRef.current[id]),
            contextState: context?.state,
            outputLatencyMs: Math.round((context?.outputLatency || 0) * 1000),
            baseLatencyMs: Math.round((context?.baseLatency || 0) * 1000),
        };
    }

    const updateAutoCount = (pCount) => {
        setAutoCount(pCount);
        if (pCount === 0) {
            setAutoBetOn(false);
        }
        setAutoBetOn(true);
        setShowAutoNumberPickerModel(false);
        if (!slotRunning) {
            setPlayMachine(pCounter => pCounter + 1);
        }
    };

    // Each line button stops its OWN reel while the spin is running:
    // Linha 1 -> reel 1, Linha 5 -> reel 2, Linha 9 -> reel 3, Linha 15 -> reel 4,
    // Linha 25 -> reel 5. Stopping the last reel still turning settles the whole
    // round (payout, paylines, sound), exactly like the Jogar button does.
    const REEL_OF_LINE = { 1: 0, 5: 1, 9: 2, 15: 3, 25: 4 };

    // Rewind before playing: play() on an already-playing tag just lets it run
    // on, so without this two quick presses would only be heard once.
    // A seek is not free: it is asynchronous and play() waits it out before a
    // single sample is heard, which is what put play-button.mp3 behind the reel
    // it belongs to. A tag that has run to the end already rewinds itself inside
    // play(), so pay for the seek only when a sound is genuinely mid-flight and
    // has to be cut short. Guarded because seeking an unbuffered tag throws, and
    // stopAllAnimation calls this before it settles the round — an escaping
    // error there would take the payout and the paylines down with the sound.
    const replaySound = (soundTagId) => {
        const audio = $("#" + soundTagId)[0];
        if (audio && !audio.ended && audio.currentTime > 0) {
            try {
                audio.currentTime = 0;
            } catch (e) { }
        }
        playSoundById(soundTagId);
    };

    // Brings down one reel by index. Stopping the last one still turning settles
    // the whole round (payout, paylines, sound) instead of waiting out the timers.
    const stopReel = (reel) => {
        // animateColumn starts life as an array but the per-reel timeouts rewrite
        // it as { ...pre, [i]: false }, so read it by index — never as an array.
        const current = animateColumnRef.current;
        const running = [0, 1, 2, 3, 4].filter((i) => current[i]);
        if (running.length === 0) return;

        if (reel === undefined || (running.length === 1 && running[0] === reel)) {
            stopAllAnimation();   // lays its own reel-landing thunk over the top
            return;
        }
        setReelStopped(reel);
    };

    // Replays every press the player made while the spin was still waiting on the
    // API, in the order they were made.
    const flushPendingStops = () => {
        const queued = pendingStopRef.current;
        pendingStopRef.current = [];
        queued.forEach((reel) => stopReel(reel));
    };

    const stopAnimation = (lineNumber) => {
        // The button always answers with its own aposta.wav — the same sound it
        // makes when the reels are idle — even on a press that stops nothing.
        replaySound("AwardWav");

        const reel = REEL_OF_LINE[lineNumber];

        // Nothing may be revealed until this spin's result is in, otherwise the
        // reels would show the previous round's symbols. The press is remembered
        // rather than dropped, so holding the button down early still feels like
        // it landed — the reel goes the moment the matrix arrives.
        if (!resultReadyRef.current) {
            if (reel !== undefined && !pendingStopRef.current.includes(reel)) {
                pendingStopRef.current.push(reel);
            }
            return;
        }

        stopReel(reel);
    };

    // Jogar doubles as the stop button, so a press must never be swallowed just
    // because the spin is still waiting on the API — that wait is what used to
    // make the second click feel dead for the whole round trip. The press is
    // remembered and honoured the instant the matrix arrives.
    const requestStopAll = () => {
        replaySound("AwardWav");

        if (!resultReadyRef.current) {
            // undefined is stopReel's "bring down every reel" case.
            if (!pendingStopRef.current.includes(undefined)) {
                pendingStopRef.current.push(undefined);
            }
            return;
        }

        stopAllAnimation();
    };

    const drawLine = (number) => {
        replaySound("AwardWav");
        setSelectedNumber(number);
        setActiveLineNumber(number);
        $(".line-show").removeClass("active");
        $(".number-show").removeClass("active");
        $(".line-show").removeClass("active1");
        Array.from({ length: number }, (_, index) => {
            let imgLine = document.getElementsByClassName(`line-show${index + 1}`);
            let imgNumber = document.getElementsByClassName(`number-show${index + 1}`);
            if (imgLine[0]) {
                imgLine[0].classList.add("active");
            }
            if (imgNumber[0]) {
                imgNumber[0].classList.add("active");
            }
        });
        let wheelBoxes = document.querySelectorAll(".wheelBox");
        wheelBoxes.forEach((wheelBox) => {
            wheelBox.classList.remove("matchbox");
        });
        let animateBlink = document.querySelectorAll(".animate-blink");
        animateBlink.forEach((wheelBox) => {
            wheelBox.classList.remove("animate-blink");
        });
    };

    const handleLineIncrease = () => {
        const currentIndex = lineOptions.indexOf(selectedNumber);
        const nextIndex = (currentIndex + 1) % lineOptions.length;
        drawLine(lineOptions[nextIndex]);
    };

    const handleLineDecrease = () => {
        const currentIndex = lineOptions.indexOf(selectedNumber);
        const nextIndex = (currentIndex - 1 + lineOptions.length) % lineOptions.length;
        drawLine(lineOptions[nextIndex]);
    };

    const increaseBetMultiplier = () => {
        playSoundById("AwardWav");
        setBetMultiplier((prevMultiplier) => {
            const currentIndex = templateData.betAmountList.findIndex((bet) => bet === prevMultiplier);
            if (currentIndex === -1) {
                return templateData.betAmountList[0];
            }

            const nextIndex = (currentIndex + 1) % templateData.betAmountList.length;
            return templateData.betAmountList[nextIndex];
        });
    };


    const decreaseBetMultiplier = () => {
        playSoundById("AwardWav");
        setBetMultiplier((prevMultiplier) => {
            const currentIndex = templateData.betAmountList.findIndex((bet) => bet === prevMultiplier);
            if (currentIndex === -1) {
                return templateData.betAmountList[0];
            }

            const nextIndex = (currentIndex - 1 + templateData.betAmountList.length) % templateData.betAmountList.length;
            return templateData.betAmountList[nextIndex];
        });
    };

    const setMaxBet = () => {
        playSoundById("AwardWav");
        if (templateData && templateData.betAmountList) {
            setBetMultiplier(templateData.betAmountList[templateData.betAmountList.length - 1]);
        }
        if (lineOptions && lineOptions.length > 0) {
            drawLine(lineOptions[lineOptions.length - 1]);
        }
    };

    const [helpSwiperInstance, setHelpSwiperInstance] = useState(null);
    const [currentIndexOfHelpSlide, setCurrentIndexOfHelpSlide] = useState(0);

    const handlePreviousHelpSlide = () => {
        if (currentIndexOfHelpSlide > 0) {
            playSoundById("ButtonClickMp3");
            const prevIndex = currentIndexOfHelpSlide - 1;
            helpSwiperInstance.slideTo(prevIndex);
            setCurrentIndexOfHelpSlide(prevIndex);
        }
    };

    const handleNextHelpSlide = () => {
        if (currentIndexOfHelpSlide < ruleImagesArray.length - 1) {
            playSoundById("ButtonClickMp3");
            const nextIndex = currentIndexOfHelpSlide + 1;
            helpSwiperInstance.slideTo(nextIndex);
            setCurrentIndexOfHelpSlide(nextIndex);
        }
    };

    function formatAmount(amount) {
        let formatter;
        try {
            formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: currency,
                minimumFractionDigits: 2,
            });
        } catch (e) {
            console.warn(`Invalid currency code "${currency}", defaulting to USD.`);
            formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
            });
        }
        return formatter.format(amount).replace(/(\D)(\d)/, '$1 $2');
    }

    const addBalance = () => {
        callPostApi(ADD_BALANCE_AMT_POST, {}, {}, (resp) => {
            if (resp.errorCode === 0) {
                setWalletBalance(resp.responsePacket)
            }
        })
    }

    const resetBalance = () => {
        callPostApi(RESET_BALANCE_AMT_POST, {}, {}, (resp) => {
            if (resp.errorCode === 0) {
                setWalletBalance(resp.responsePacket)
            }
        })
    }

    useEffect(() => {
        const handleKeyPress = (event) => {
            const key = event.key.toLowerCase();
            const disabled = jogarButtonFlag || buttonFlag || isBalanceAdding;

            if (key === "t") {
                if (!disabled) {
                    playSoundById("ButtonClickMp3");

                    if (!showHelpModel) {
                        setShowHelpModel(true);
                        setCurrentIndexOfHelpSlide(0);

                        setTimeout(() => {
                            if (helpSwiperInstance) {
                                helpSwiperInstance.slideTo(0);
                            }
                        }, 100);
                    } else {
                        if (currentIndexOfHelpSlide < ruleImagesArray.length - 1) {
                            const nextIndex = currentIndexOfHelpSlide + 1;
                            helpSwiperInstance?.slideTo(nextIndex);
                            setCurrentIndexOfHelpSlide(nextIndex);
                        } else {
                            setShowHelpModel(false);
                        }
                    }
                }
            } else if (key === "y") {
                slotRunning ? stopAnimation(1) : drawLine(1);
            } else if (key === "j") {
                slotRunning ? stopAnimation(5) : drawLine(5);
            } else if (key === "h") {
                slotRunning ? stopAnimation(9) : drawLine(9);
            } else if (key === "m") {
                slotRunning ? stopAnimation(15) : drawLine(15);
            } else if (key === "n") {
                slotRunning ? stopAnimation(25) : drawLine(25);
            } else if (key === "g" && !jogarButtonFlag && !buttonFlag && !isBalanceAdding) {
                increaseBetMultiplier();
            } else if (key === "p" && !jogarButtonFlag && !buttonFlag && !isBalanceAdding) {
                addBalance();
            } else if (key === "r" && !jogarButtonFlag && !buttonFlag && !isBalanceAdding && walletBalance > 0) {
                if (!resetAmntModel) {
                    setResetAmntModel(true);
                } else {
                    setResetAmntModel(false);
                    resetBalance();
                }
            } else if (key === "v" && !jogarButtonFlag && !buttonFlag && !isBalanceAdding) {
                if (!autoBetOn) {
                    setAutoBetOn(true);
                    setAutoCount(-1);
                } else {
                    setAutoBetOn(false);
                    setAutoCount(0);
                }
                setPlayMachine((p) => p + 1);
            } else if (key === "b" && !jogarButtonFlag && !isBalanceAdding) {
                setAutoBetOn(false);
                setAutoCount(0);
                if (slotRunning) {
                    stopAllAnimation();
                } else {
                    placeBet();
                }
            }
        };
        if (showBonusModel) {
            window.removeEventListener("keydown", handleKeyPress);
        }
        else if (keyboardInput) {
            window.addEventListener("keydown", handleKeyPress);
            return () => {
                window.removeEventListener("keydown", handleKeyPress);
            };
        }
    }, [jogarButtonFlag, showBonusModel, walletBalance, selectedNumber, betMultiplier, resetAmntModel, buttonFlag, autoBetOn, templateNumber, slotRunning, showHelpModel, currentIndexOfHelpSlide, helpSwiperInstance, ruleImagesArray.length, isBalanceAdding]);
    const getApostaMaxButton = () => {
        return (
            <span
                onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                className="position-relative aposta-max-btn-img footer-btn-custom"
                onClick={() => increaseBetMultiplier()} disabled={jogarButtonFlag}>
                <img className="img-fluid img-normal" src="assets/img/aposta-btn-img.png" alt="" />
                <img className="img-fluid img-active" src="assets/img/aposta-btn-img-active.png" alt="" />
            </span>
        )
    }


    const getFooterLineButtonSection = () => {
        return (
            <>
                <div className="bomba-footer align-items-center justify-content-between w-100">
                    <span
                        className="position-relative menu-btn-img footer-btn-custom"
                        onClick={() => navigate(-1)}
                        onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                        onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                        onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                        style={{ cursor: 'pointer' }}
                    >

                        <img className="img-fluid img-normal" src="assets/img/red-btn-img.png" alt="" />
                        <img className="img-fluid img-active" src="assets/img/red-btn-img-active.png" alt="" />
                        {/* <span className="btn-red position-absolute top-0 end-0 bottom-0 start-0">
                            <span className="btn-name">Menu</span>
                        </span> */}
                    </span>
                    {[1, 5, 9, 15, 25].map(num => (
                        <span
                            key={num}
                            className={`position-relative linha-${num}-btn footer-btn-custom`}
                            onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                            onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                            onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                            onClick={() => {
                                if (slotRunning) {
                                    stopAnimation(num);
                                    return;
                                }
                                drawLine(num);
                            }}
                        >
                            <img className="img-fluid img-normal" src={`assets/img/linha-img-${num}.png`} alt="" />
                            <img className="img-fluid img-active" src={`assets/img/linha-img-active-${num}.png`} alt="" />
                        </span>
                    ))}
                    <span
                        className={`position-relative auto-btn-img footer-btn-custom ${autoBetOn ? "btn-line-active" : ""}`}
                        onClick={() => {
                            if (!autoBetOn) {
                                setAutoBetOn(true);
                                setAutoCount(-1);
                            } else {
                                setAutoBetOn(false);
                                setAutoCount(0);
                            }
                            setPlayMachine(pCounter => pCounter + 1);
                        }}
                        onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                        onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                        onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                        disabled={jogarButtonFlag || buttonFlag}
                    >

                        <img className="img-fluid img-normal" src="assets/img/auto-btn-img.png" alt="" />
                        <img className="img-fluid img-active" src="assets/img/auto-btn-img-active.png" alt="" />
                        <span className="btn-yellow position-absolute top-0 end-0 bottom-0 start-0">
                            {/* <span className="btn-name">Auto</span> */}
                        </span>
                    </span>
                    <span
                        onClick={() => {
                            playSoundById("ButtonClickMp3");
                            setShowAjudaModel(true);
                        }}
                        onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                        onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                        onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                        className="position-relative help-btn-img footer-btn-custom"
                        disabled={jogarButtonFlag || buttonFlag}
                    >

                        <img className="img-fluid img-normal" src="assets/img/blue-btn-img.png" alt="" />
                        <img className="img-fluid img-active" src="assets/img/blue-btn-img-active.png" alt="" />
                        <span className="btn-yellow position-absolute top-0 end-0 bottom-0 start-0">
                            {/* <span className="btn-name">Ajuda</span> */}
                        </span>
                    </span>
                    {getApostaMaxButton()}
                    <span
                        onMouseDown={(e) => e.currentTarget.classList.add('btn-line-active')}
                        onMouseUp={(e) => e.currentTarget.classList.remove('btn-line-active')}
                        onMouseLeave={(e) => e.currentTarget.classList.remove('btn-line-active')}
                        className={`position-relative jogar-btn-img footer-btn-custom ${jogarButtonFlag ? "btn-line-active" : ""}`}
                        onClick={(e) => {
                            setAutoBetOn(false);
                            setAutoCount(0);
                            if (slotRunning) {
                                requestStopAll();
                            } else {
                                replaySound("AwardWav");
                                placeBet();
                            }
                        }}
                        // Only locked out while the winnings are counting up.
                        // During the spin it IS the stop button, so it has to stay
                        // live — span[disabled] kills pointer-events entirely.
                        disabled={jogarButtonFlag && !slotRunning}
                    >

                        <img className="img-fluid img-normal" src="assets/img/jogar-btn-img.png" alt="" />
                        <img className="img-fluid img-active" src="assets/img/jogar-btn-img-active.png" alt="" />
                        {/* <span className="btn-red position-absolute top-0 end-0 bottom-0 start-0">
                            <span className="btn-name">Jogar</span>
                        </span> */}
                    </span>
                </div>
            </>
        );
    }

    const toggleAutoButtonModel = () => {
        if (!buttonFlag && !isBalanceAdding) {
            playSoundById("ButtonClickMp3");
            setShowAutoNumberPickerModel(!showAutoNumberPickerModel);
        }
    };

    const handleCancelAutoBet = () => {
        playSoundById("ButtonClickMp3");
        setAutoCount(0);
        setAutoBetOn(false);
        setShowAutoNumberPickerModel(false);
    };

    const toggleSettingModel = () => {
        playSoundById("ButtonClickMp3");
        setShowSettingModel(!showSettingModel);
    };

    const [currentFlagIndex, setCurrentFlagIndex] = useState(0);
    const flagImg = ["assets/img/br.png", "assets/img/en.png", "assets/img/es.png"];

    const handleFlagChange = () => {
        playSoundById("ButtonClickMp3");
        const nextIndex = (currentFlagIndex + 1) % flagImg.length;
        setCurrentFlagIndex(nextIndex);
    };

    const getAutoButtonModel = () => {
        return !showAutoNumberPickerModel ? <></> : <div className="bottom-left-div">
            <div className="cursor-pointer w-100 d-flex align-items-center justify-content-center turn-btn px-2 py-1"
                onClick={handleCancelAutoBet}>DESLIGAR</div>
            <div className="auto-digits mt-2">
                <div className="row">
                    <div className="col-4">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(10)}
                        >10</div>
                    </div>
                    <div className="col-4">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(25)}
                        >25</div>
                    </div>
                    <div className="col-4">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(50)}
                        >50</div>
                    </div>
                    <div className="col-4 mt-2">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(100)}
                        >100</div>
                    </div>
                    <div className="col-4 mt-2">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(250)}
                        >250</div>
                    </div>
                    <div className="col-4 mt-2">
                        <div className="digits d-flex align-items-center justify-content-center cursor-pointer"
                            onClick={() => updateAutoCount(-1)}
                        >∞</div>
                    </div>
                </div>
            </div>
        </div>
    }

    const getHelpModel = () => {
        return <ModalHalloween show={showHelpModel} toggleModel={() => setShowHelpModel(false)}>
            <div className="modal-dialog modal-fullscreen">
                <div className="modal-content" style={{ background: "#0a0f29" }}>
                    <div className="modal-header position-relative">
                        <h6 className="m-0">Prize Table</h6>
                    </div>
                    <div className="modal-body text-center p-0 bg-help">
                        <div className="h-100">
                            <Swiper onSwiper={(swiper) => setHelpSwiperInstance(swiper)} navigation={false} loop={false} className="mySwiper">
                                {ruleImagesArray.map((rule, i) => (
                                    <SwiperSlide key={i}>
                                        <img src={rule} alt={`rules-${i}`} className="img-fluid w-100 h-100" />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                            <div className="position-absolute back-btn">
                                <button id="prev-btn" className="slick-arrow slick-prev" onClick={() => handlePreviousHelpSlide()}
                                    style={{ color: "white", position: "unset", transform: "none", opacity: currentIndexOfHelpSlide === 0 ? 0.5 : 1 }}>Prev</button>
                                <button className="btn-grey text-center" onClick={() => {
                                    playSoundById("ButtonClickMp3");
                                    setShowHelpModel(false);
                                }}>Back</button>
                                <button id="next-btn" className="slick-arrow slick-next" onClick={() => handleNextHelpSlide()}
                                    style={{ color: "white", position: "unset", transform: "none", opacity: currentIndexOfHelpSlide === ruleImagesArray.length - 1 ? 0.6 : 1 }}>Next</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ModalHalloween>;
    }

    const onBonusRoundCompleted = (pTotalBonus) => {
        setShowBonusModel(false);
        if (pTotalBonus > 0) {
            let ptotalGameBonus = pTotalBonus;
            setWinnings(ptotalGameBonus);

            if (accumuladoWin.winAmount > 0) {
                setShowCoins(true)
                setTimeout(() => {
                    setShowCoins(false)
                    animateAccumuladoWinning(walletBalance, accumuladoWin.winAmount, accumuladoWin.winIndex);
                    playWinningAnimation(walletBalance, ptotalGameBonus, accumuladoWin.winAmount);
                }, 25000)
            }
            else {
                playWinningAnimation(walletBalance, ptotalGameBonus, accumuladoWin.winAmount);
            }
            let countTime = 5000;
            if (accumuladoWin.winAmount > 0) {
                countTime = 38000;
            }

            if (autoBetOn) {
                var pAutoBetTimeOutRef = setTimeout(() => {
                    setAutoCount(prevCount => {
                        if (prevCount > 0) {
                            return prevCount - 1;
                        } else if (prevCount === 0) {
                            return 0;
                        } else {
                            return -1;
                        }
                    });
                    setPlayMachine(pCounter => pCounter + 1);
                }, countTime);
                setAutoBetTimeOutRef(pAutoBetTimeOutRef);
            }

        }
    };

    const bonusModel = () => {
        if (gameResult === null || isEmpty(gameResult.bonusType) || gameResult.bonusType === "None") {
            return <></>;
        }
        const renderBonusContent = () => {
            switch (gameResult.bonusType) {
                case "Bonus01Strawberry":
                    return (
                        <Bonus01BombaStrawberry
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus02Roulette":
                    return (
                        <BombaRouletteBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            gameResult={gameResult}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus03ACauldron":
                    return (
                        <BombaCauldronBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            gameResult={gameResult}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus04Dice":
                    return (
                        <HalloweenDiceBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            gameResult={gameResult}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus05LittleWitchPumpkinPulling":
                    return (
                        <PumpkinBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            gameResult={gameResult}
                        />
                    );
                case "Bonus06PoolSpinsLightWitch":
                    return (
                        <PoolSpinBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            gameResult={gameResult}
                            keyboardInput={keyboardInput}
                        />

                    );
                case "Bonus07GiraLuz":
                    return (
                        <GiraLuzBonus
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            gameResult={gameResult}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus08SpinningStrawberry":
                    return (
                        <Bonus08SpinningStrawberry
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus09Bomb":
                    return (
                        <Bonus09Bomb
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            keyboardInput={keyboardInput}
                        />
                    );
                case "Bonus10Bomb":
                    return (
                        <Bonus10Bomb
                            gameSessionRecordId={gameResult.recordId}
                            onBonusRoundCompleted={onBonusRoundCompleted}
                            walletBalance={walletBalance}
                            denomination={denomination}
                            keyboardInput={keyboardInput}
                        />
                    );
                default:
                    return null;
            }
        };
        return <>
            <ModalHalloween show={showBonusModel} toggleModel={() => { }}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "transparent" }}>
                        <div className="modal-body text-center p-0 bg-transparent" style={{ background: "transparent" }}>
                            <div className="h-100">
                                {renderBonusContent()}
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>
        </>
    }

    const BombaHeader = () => {
        // Read from state (not accumuladoList[2]) so the number list highlight is
        // applied only when the ball arrives, in sync with the left-side reveal.
        const bonusNumberMap = accumuladoBonusNumberMap || {};

        const mapEntries = Object.entries(bonusNumberMap).sort((a, b) => {
            const numA = parseInt(a[0]);
            const numB = parseInt(b[0]);
            return numA - numB;
        });

        const displayEntries = [...mapEntries];
        while (displayEntries.length < 6) {
            displayEntries.push(['-', false]);
        }

        const totalBetAmount = getFormattedAmountWithDenomination(betMultiplier, denomination) * selectedNumber;
        const isBetGreaterThan25 = totalBetAmount > 25;


        const getBonusBackgroundImage = (number) => {
            if (number === null || number === undefined) return null;

            if (number >= -1 && number <= 9) {
                return "Halloween assets/Group 298.png";
            } else if (number >= 10 && number <= 19) {
                return "Halloween assets/Group 306.png";
            } else if (number >= 20 && number <= 29) {
                return "Halloween assets/Group 307.png";
            } else if (number >= 30 && number <= 39) {
                return "Halloween assets/Group 308.png";
            } else if (number >= 40 && number <= 49) {
                return "Halloween assets/Group 309.png";
            } else if (number >= 50 && number <= 59) {
                return "Halloween assets/Group 311.png";
            } else if (number >= 60 && number <= 69) {
                return "Halloween assets/Group 312.png";
            } else if (number >= 70 && number <= 79) {
                return "Halloween assets/Group 313.png";
            } else if (number >= 80 && number <= 89) {
                return "Halloween assets/Group 310.png";
            } else if (number >= 90) {
                return "Halloween assets/Group 314.png";
            }
            return null;
        };

        const getTextColor = (number) => {
            return number === 90 ? 'white' : 'black';
        };

        const getLeftSideContent = () => {
            if (totalBetAmount <= 25) {
                return (
                    <img
                        src="Halloween assets/text.png"
                        alt="bonus-text"
                        style={{ width: '70%', height: '70%', objectFit: 'contain', display: 'block' }}
                    />
                );
            }

            if (leftImage === 'bonus') {
                const currentBonusNumber = accumuladoBonusNumber ?? gameResult?.accumuladoList?.[2]?.accumuladoMetaData?.accumuladoBonusNumber;
                const bgImage = getBonusBackgroundImage(currentBonusNumber);
                const textColor = getTextColor(currentBonusNumber);

                if (bgImage) {
                    return (
                        <div style={{ position: 'relative', width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <img
                                src={bgImage}
                                alt={`bonus-${currentBonusNumber}`}
                                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '100%' }}
                            />
                            <span style={{
                                position: 'absolute',
                                color: textColor,
                                fontWeight: '900',
                                fontSize: '4vw',
                                letterSpacing: '0.5px',
                                textShadow: textColor === 'white'
                                    ? '0 0 4px #000, 1px 1px 3px #000, -1px -1px 3px #000'
                                    : '0 0 4px #fff, 1px 1px 3px #fff, -1px -1px 3px #fff'
                            }}>
                                {currentBonusNumber}
                            </span>
                        </div>
                    );
                }

                return (
                    <span style={{
                        color: 'white',
                        fontWeight: '900',
                        fontSize: '4vw',
                        textShadow: '0 0 4px #000, 1px 1px 3px #000, -1px -1px 3px #000'
                    }}>
                        {currentBonusNumber}
                    </span>
                );
            }

            if (leftImage === 'group') {
                return (
                    <img
                        src="Halloween assets/Group.png"
                        alt="bonus-group"
                        style={{ width: '70%', height: '70%', objectFit: 'contain', display: 'block' }}
                    />
                );
            }

            return (
                <img
                    src="Halloween assets/text.png"
                    alt="bonus-text"
                    style={{ width: '70%', height: '70%', objectFit: 'contain', display: 'block' }}
                />
            );
        };

        const shouldBlurAccumuladoActual = () => {
            const currentTotalBet = betMultiplier * selectedNumber;
            return currentTotalBet <= 25 && gameResult === null;
        };

        useEffect(() => {
            console.log('Bet value changed:', totalBetAmount);
        }, [betMultiplier, selectedNumber, totalBetAmount]);

        const blurResult = shouldBlurAccumuladoActual();
        console.log('Final Blur Result:', blurResult);

        const calculatedValue = useMemo(() => {
            return getFormattedAmountWithDenomination(betMultiplier, denomination) * selectedNumber;
        }, [betMultiplier, denomination, selectedNumber]);

        const shouldShowPago = pagoWinningCounter !== null && pagoWinningCounter > 0;

        return (
            <div className="">
                <div className="row">
                    <div className="col-6 pe-0">
                        <div className="d-flex h-100 ">
                            <div className="col-12 p-0 position-relative">
                                <img className="w-100 h-100" src="assets/img/bomba-table-img.png" alt="" />
                                <div className="table-content">
                                    <div className="left-side">
                                        {getLeftSideContent()}
                                    </div>
                                    <div className="right-side">
                                        <div className="top-table">
                                            <ul style={{
                                                margin: 0,
                                                padding: 0,
                                                listStyle: 'none',
                                                textAlign: 'center'
                                            }}>
                                                {displayEntries.map(([number, isSelected], index) => (
                                                    <li
                                                        key={`${number}-${index}`}
                                                        className={(isSelected === true || isSelected === 'true') ? 'custom-bg-black' : undefined}
                                                    >
                                                        {number}
                                                    </li>
                                                ))}

                                                <li>
                                                    {(() => {
                                                        const num = accumuladoActualValue;
                                                        if (num === null || num === undefined) return '0.00';

                                                        const numericValue = typeof num === 'string' ? parseFloat(num) : num;

                                                        return numericValue.toFixed(2);
                                                    })()}
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="h-100 bottom-div position-relative">
                                            <div className="gratis-text-div">
                                                <div>
                                                    {remainingFreeSpin > 0 && (
                                                        <span className="gratis-text">GRATIS : {remainingFreeSpin}</span>
                                                    )}
                                                </div>
                                                <div className="fs-1-5 h-100 d-flex flex-column align-center text-center text-white justify-content-end pagofont">
                                                    {shouldShowPago && (
                                                        <>
                                                            <div>PAGO:</div>
                                                            <span>{pagoWinningCounter}</span>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="row">
                            <div className="col-10 position-relative">
                                <div className="d-flex gap-2 halloween-bomba-game-header">
                                    <div className="w-100 text-center btn-row-header">
                                        <img src="assets/img/credit.png" alt="credit" className="img-fluid" />
                                        <div className="btn-custom d-flex align-items-center justify-content-center w-100">
                                            <span className="btn-custom-outer w-100">
                                                <span className="btn-custom-inner d-flex align-items-center justify-content-center text-white w-100">
                                                    {getFormattedAmountWithDenomination(walletBalance, denomination)}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="w-100 text-center btn-row-header">
                                        <img src="assets/img/award.png" alt="award" className="img-fluid" />
                                        <div className="btn-custom d-flex align-items-center justify-content-center w-100">
                                            <span className="btn-custom-outer w-100">
                                                <span className="btn-custom-inner d-flex align-items-center justify-content-center text-white w-100">
                                                    {winnings}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <div className="w-100 text-center btn-row-header">
                                        <img src="assets/img/bet.png" alt="bet" className="img-fluid w-100" />
                                        <div className="btn-custom d-flex align-items-center justify-content-center w-100">
                                            <span className="btn-custom-outer w-100">
                                                <span className="btn-custom-inner d-flex align-items-center justify-content-center text-white w-100">
                                                    {calculatedValue}
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-2 p-0">
                                <div className="text-center position-relative">
                                    <img src="assets/img/no-img.png" alt="credit" className="img-fluid header-mb mx-auto" />
                                    <span className="position-absolute top-0 start-0 end-0 bottom-0 Bomba-no">{Math.round(betMultiplier / 0.01)}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const getBottomPrizeSection = () => {
        return (
            <div className="d-flex align-items-end justify-content-between future-price position-relative z-1 gap-2">
                <div className="d-block position-relative custom-w20">
                    <div className="position-relative">
                        <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                        <span className="btn-content">{formatAmount(accumuladoList[0]?.accumuladoActual || 0)}</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/diaboIcon.png" className="img-fluid" alt="diaboIcon" /></div>
                    </div>
                </div>
                <div className="d-flex align-items-end justify-content-center">
                    <div className="w-auto text-center bomba-img-height">
                        <img className="img-fluid w-100 h-100" src="assets/img/logo-bomba.png" alt="" />
                    </div>
                    <div className="w-auto text-center">
                        <span className="d-flex align-items-center justify-content-center position-relative mx-auto bomba-img-height">
                            <img className="img-fluid w-100 h-100" src="assets/img/bomba-img.png" alt="" />
                            <img className="img-fluid position-absolute top-0 end-0 spin-animation" src="assets/img/pavio-img.png" alt="" />
                        </span>
                    </div>
                </div>
                <div className="d-block position-relative custom-w20">
                    <div className="position-relative">
                        <img className="btnImg" src="assets/img/btn-bg.png" alt="" />
                        <span className="btn-content">{formatAmount(accumuladoList[1]?.accumuladoActual || 0)}</span>
                    </div>
                    <div className="d-flex align-items-center justify-content-center" style={{ marginTop: "-20px" }}>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                        <div className="halloween-wh d-flex align-items-center justify-content-center"><img src="assets/img/aboboraIcon.png" className="img-fluid" alt="aboboraIcon" /></div>
                    </div>
                </div>
            </div>
        );
    }

    const staticResources = {
        characters: [
            "assets/img/diabo.png",
            "assets/img/vampire.png",
            "assets/img/fantasma.png",
            "assets/img/espanthalho.png",
            "assets/img/abobora.png",
            "assets/img/frankenstein.png",
            "assets/img/calderao.png",
            "assets/img/bruxa.png",
            "assets/img/bruxinha.png",
            "assets/img/magica.png"
        ],
        sliderImages: Array.from({ length: 10 }, (_, i) => `assets/img/sliderImage/${i}.jpg`),
        soundImages: [
            "/assets/img/sound/sound-0.00.png",
            "/assets/img/sound/sound-0.25.png",
            "/assets/img/sound/sound-0.50.png",
            "/assets/img/sound/sound-0.75.png",
            "/assets/img/sound/sound-1.00.png"
        ],
        strawberriesImages: [
            "/assets/img/strawberries/anim-abrindo.gif",
            "/assets/img/strawberries/anim-girando.gif",
            "/assets/img/strawberries/bg.png",
            "/assets/img/strawberries/fim-do-bonus.gif"
        ],
        rouletteImages: [
            "/assets/img/Roulette/bg.png",
            "/assets/img/Roulette/header-bar.png",
            "/assets/img/Roulette/score-btn.png",
            "/assets/img/Roulette/seta.png",
            "/assets/img/Roulette/wheel.png"
        ],
        giraLuzImages: [
            "/assets/img/GiraLuz/gamePlay-img.png"
        ],
        poolSpinImages: [
            "/assets/img/poolSpin/bol0.png",
            "/assets/img/poolSpin/bol1.png",
            "/assets/img/poolSpin/bol2.png",
            "/assets/img/poolSpin/bol3.png",
            "/assets/img/poolSpin/bol4.png",
            "/assets/img/poolSpin/bol5.png",
            "/assets/img/poolSpin/bol6.png",
            "/assets/img/poolSpin/bol7.png",
            "/assets/img/poolSpin/bol8.png",
            "/assets/img/poolSpin/bol9.png",
            "/assets/img/poolSpin/jogador.gif",
            "/assets/img/poolSpin/mesa.gif",
            "/assets/img/poolSpin/roll.gif",
            "/assets/img/poolSpin/taco.gif",
            "/assets/img/poolSpin/triangulo.gif",
            "/assets/img/poolSpin/sec-bottom.png",
            "/assets/img/poolSpin/sec-middle.png",
            "/assets/img/poolSpin/sec-top.png"
        ],
        pumpkinImages: [
            "/assets/img/pumpkin/anim-pumpkin.gif",
            "/assets/img/pumpkin/anim-witch.gif",
            "/assets/img/pumpkin/bg.png",
            "/assets/img/pumpkin/box-bg.png"
        ],
        cauldronImages: [
            "/assets/img/cauldron/anim-idle.gif",
            "/assets/img/cauldron/anim-idle-0.gif",
            "/assets/img/cauldron/anim-idle-1.gif",
            "/assets/img/cauldron/anim-idle-2.gif",
            "/assets/img/cauldron/anim-idle-3.gif",
            "/assets/img/cauldron/anim-idle-4.gif",
            "/assets/img/cauldron/anim-selected.gif",
            "/assets/img/cauldron/anim-selected.jpg",
            "/assets/img/cauldron/btn-bg.png",
            "/assets/img/cauldron/bg.jpg",
            "/assets/img/cauldron/caldeirao.gif",
            "/assets/img/cauldron/caldeirao-abobora-bonus.png",
            "/assets/img/cauldron/caldeirao-abobora-frase.png",
            "/assets/img/cauldron/caldeirao-abobora-multiplique.png",
            "/assets/img/cauldron/caldeirao-bonus.png",
            "/assets/img/cauldron/caldeirao-frase.png",
            "/assets/img/cauldron/caldeirao-multiplique.png",
            "/assets/img/cauldron/footer-logo.png",
            "/assets/img/cauldron/header-logo.png",
            "/assets/img/cauldron/premioBonusAbobora.png",
            "/assets/img/cauldron/text1.png",
            "/assets/img/cauldron/text2.png",
            "/assets/img/cauldron/text3.png"
        ],
        diceImages: [
            "/assets/img/DIceBonus/bg.png",
            "/assets/img/DIceBonus/header-bar.png",
            "/assets/img/DIceBonus/score-btn.png",
            "/assets/img/DIceBonus/dice.gif",
            "/assets/img/DIceBonus/dice-1.png",
            "/assets/img/DIceBonus/dice-2.png",
            "/assets/img/DIceBonus/dice-3.png",
            "/assets/img/DIceBonus/dice-4.png",
            "/assets/img/DIceBonus/dice-5.png",
            "/assets/img/DIceBonus/dice-6.png"
        ],
        audioFiles: [
            { id: "SlotMp3", src: "assets/giro_loop.mp3" },
            { id: "Win45Wav", src: "assets/winners_4.ogg" },
            { id: "AwardWav", src: "assets/aposta.wav" },
            { id: "ButtonClickMp3", src: "assets/standardClick.mp3" },
            { id: "ErrorMp3", src: "assets/error.mp3" },
            { id: "CreditsCounterMp3", src: "assets/number_count.mp3" },
            { id: "WheelStopWav", src: "assets/wheel-stop.wav" },
            { id: "BolaOgg", src: "assets/bola.ogg" }
        ],
        dynamicDiceImages: Array.from({ length: 80 }, (_, i) => `assets/img/DIceBonus/(${i}).webp`)
    };

    // The <source> type is a load-time hint the browser trusts: declaring
    // audio/mpeg over a .wav or .ogg makes it pick the source and only then
    // discover the real format, which it has to re-sniff before it can play.
    const getAudioMimeType = (src) => {
        if (src.endsWith(".wav")) return "audio/wav";
        if (src.endsWith(".ogg")) return "audio/ogg";
        return "audio/mpeg";
    };

    const loadStaticResources = () => {
        return <>
            <div style={{ display: "none" }}>
                {staticResources.characters.map((src, index) => (
                    <img key={`char-${index}`} className="img-fluid" src={src} alt="" />
                ))}

                {staticResources.sliderImages.map((src, index) => (
                    <img key={`slider-${index}`} src={src} alt="" />
                ))}

                {staticResources.soundImages.map((src, index) => (
                    <img key={`sound-${index}`} src={src} alt="" />
                ))}

                {staticResources.strawberriesImages.map((src, index) => (
                    <img key={`strawberry-${index}`} src={src} alt="" />
                ))}

                {staticResources.rouletteImages.map((src, index) => (
                    <img key={`roulette-${index}`} src={src} alt="" />
                ))}

                {staticResources.giraLuzImages.map((src, index) => (
                    <img key={`giraLuz-${index}`} src={src} alt="" />
                ))}

                {staticResources.poolSpinImages.map((src, index) => (
                    <img key={`poolSpin-${index}`} src={src} alt="" />
                ))}

                {staticResources.pumpkinImages.map((src, index) => (
                    <img key={`pumpkin-${index}`} src={src} alt="" />
                ))}

                {staticResources.cauldronImages.map((src, index) => (
                    <img key={`cauldron-${index}`} src={src} alt="" />
                ))}

                {staticResources.diceImages.map((src, index) => (
                    <img key={`dice-${index}`} src={src} alt="" />
                ))}

                {staticResources.audioFiles.map((audio, index) => (
                    <audio key={`audio-${index}`} controls="" id={audio.id} className="audioFile" preload="auto">
                        <source src={audio.src} type={getAudioMimeType(audio.src)} />
                    </audio>
                ))}

                {staticResources.dynamicDiceImages.map((src, index) => (
                    <img key={`dynamicDice-${index}`} src={src} alt="" />
                ))}
            </div>
        </>
    }

    return (
        <>
            {showCoins && <CoinContainer />}

            <BombaHeader />
            <div className="main-content">
                <div className="w-100 h-100 d-flex flex-column ">
                    <div className={`game-container cPb halloween-bomba-game`}>
                        {autoBetOn && <div className="AutoText"> JOGA AUTOMATICO</div>}
                        <HalloweenMachine ref={machineRef} gameResult={gameResult} animateColumn={animateColumn} stopMachineFlag={stopMachineFlag} />
                        <LineImages templateData={templateData} templateNumber={templateNumber} activeLine={activeLineNumber} />
                        <NumberLineImages templateData={templateData} templateNumber={templateNumber} activeLine={activeLineNumber} />
                        {showInsufficientFundModel && (
                            <div className="balance-popup text-white">
                                <div className="content">
                                    <p className="mb-0">Insira Creditos</p>
                                </div>
                            </div>
                        )}
                        {resetAmntModel && (
                            <div className="resetBalance-popup text-white">
                                <div className="content">
                                    <div className="ser-no-text">N.SEC. 001</div>
                                    <div style={{ margin: "30px 0" }}>
                                        <p className="mb-0">FAVOR CHAMAR 0 OPERADOR</p>
                                        <p className="mb-4">PARA RECEBER SEUS CREDITOS</p>
                                        <p className="mb-0">CREDITOS: {getFormattedAmountWithDenomination(walletBalance, denomination)}</p>
                                        <p className="mb-4">{formatAmount(walletBalance)}</p>
                                    </div>
                                    <div className="ser-no-text">VALIDACAO : 538978871</div>
                                </div>
                            </div>
                        )}
                    </div>
                    {getBottomPrizeSection()}
                </div>
            </div>

            <div className="footer">
                {getFooterLineButtonSection()}
            </div>

            {showFreeSpinBanner && (
                <div className="d-flex justify-content-center align-items-center" style={{ position: 'fixed', inset: 0, zIndex: 9999 }}>
                    <img src="assets/img/bomba/telarg.png" alt="" style={{ width: '100%', height: "100%" }} />
                </div>
            )}

            {getHelpModel()}
            {loadStaticResources()}
            {bonusModel()}

            <ModalHalloween show={showAjudaModel} toggleModel={() => { }}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "#0a0f29" }}>
                        <div className="modal-body text-center p-0 bg-help">
                            <div className="h-100">
                                <img onClick={() => { setShowBonusBombaModel(true); }} className="w-100 h-100" src="assets/img/tabela-img.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>

            <ModalHalloween show={showBonusBombaModel} toggleModel={() => { }}>
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "transparent" }}>
                        <div className="modal-body text-center p-0" style={{ background: "transparent" }}>
                            <div className="h-100">
                                <img onClick={() => { setShowBonusBombaModel(false); setShowAjudaModel(false) }} className="w-100 h-100" src="assets/img/bonus-bomba-img.png" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </ModalHalloween>
        </>
    );
};

export default HalloweenBombaGame;